<template>
  <section class="promoter-stats statistics">
    <Breadcrumbs
      :breadcrumbs="[
        { title: $t('menu.statistics'), disabled: true },
        { title: $t('menu.promoterstatistics'), disabled: true }
      ]">
    </Breadcrumbs>

    <form class="evollu-form">
      <div class="row">
        <div class="col-12 col-sm-5">
          <label class="form-label">{{$t('promoterstatistics.select_promoter')}}</label>
          <multiselect
            id="entities-multiselect"
            v-model="filters.promoters"
            :options="promoterstats"
            track-by="promoter_id"
            label="promoter_name"
            :placeholder="promoterstats.length ? $t('promoterstatistics.select_promoter') : $t('promoterstatistics.no_promoters')"
            :allow-empty="true"
            :multiple="true"
            :searchable="true"
            :disabled="!isFromEvollu || promoterstats.length < 2"
          >
            <span slot="noResult">{{$t('patients.noResults')}}</span>
            <template slot="clear" slot-scope="props" v-if="isFromEvollu && filters.promoters.length">
              <div id="entities-multiselect-clear" class="multiselect__clear" @mousedown.prevent.stop="filters.promoters = []"></div>
            </template>
          </multiselect>
        </div>

        <div class="col-12 col-sm-4">
          <RangeDatePicker
            id="range-date-picker"
            :label="`${$t('statistics.daterange_start')} ${$t('statistics.daterange_created_at')}:`"
            v-model="filters.dateRange"
            placeholder="---"
            :clearable="false"
            :disabled="isLoading"
          >
          </RangeDatePicker>
        </div>
      </div>
    </form>

    <ranking-graph
      v-if="!isLoading && promoterstats.length > 0"
      class="mb-5"
      :key="graph.id"
      :graph="graph"
      :pagination="{show: false, perPage: 5}">
    </ranking-graph>

    <div v-show="!isLoading && !isFromEvollu && filters.promoters.length == 0" class="mb-3">
      <div class="col-md-12 text-center">
        <span>{{$t('pyramid.no_data')}}</span>
      </div>
    </div>

    <div v-show="!isLoading" class="row promoter-stats-content" v-for="promoter in filters.promoters"  :key="promoter.promoter_id">

      <div class="col-sm-6 col-lg-2 pr-3 section">
        <h5 class="section-title">{{promoter.promoter_name}}</h5>
        <div class="row">
          <div class="col-sm-12">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ promoter.session_ids.length }}
                  </div>
                  <div class="text-center">{{$t('pharmastatistics.screenings')}}</div>
                </div>
              </div>
            </va-card>
          </div>
        </div>
        <div class="row bottom-row">
          <div class="col-sm-12">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ promoter.submitted + promoter.cancelled }}
                  </div>
                  <div class="text-center">{{$t('kiosks.graph.tests')}}</div>
                </div>
              </div>
            </va-card>
          </div>
        </div>
      </div>

      <div class="col-sm-6 col-lg-3 px-3 section">
        <h5 class="section-title">{{$t('statistics.registos')}}</h5>
        <div class="row">
          <div class="col-sm-6">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ promoter.submitted_no_hl }}
                  </div>
                  <div class="text-center">{{$t('statistics.tests_no_loss')}}</div>
                </div>
              </div>
            </va-card>
          </div>
          <div class="col-sm-6 ">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ promoter.submitted_hl }}
                  </div>
                  <div class="text-center">
                    <div class="text-center">{{$t('pharmastatistics.qualified_leads')}}</div>
                    <!-- <vuestic-tooltip :options="{content: this.$t('pharmastatistics.qualified_leads_tooltip'), placement: 'bottom'}">
                      {{$t('pharmastatistics.qualified_leads')}}
                      <i class="fa fa-info-circle"></i>
                    </vuestic-tooltip> -->
                  </div>
                </div>
              </div>
            </va-card>
          </div>
        </div>
        <div class="row bottom-row">
          <div class="col-sm-6">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ promoter.cancelled_no_hl }}
                  </div>
                  <div class="text-center">{{$t('statistics.cancelled_tests_no_loss')}}</div>
                </div>
              </div>
            </va-card>
          </div>
          <div class="col-sm-6">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ promoter.cancelled_hl }}
                  </div>
                  <div class="text-center">{{$t('statistics.cancelled_tests_loss')}}</div>
                </div>
              </div>
            </va-card>
          </div>
        </div>
      </div>

      <div class="col-sm-6 col-lg-2 px-3 section">
        <h5 class="section-title">{{$t('promoterstatistics.contacts')}}</h5>
        <div class="row">
          <div class="col-sm-12">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ promoter.scheduled_appointments + promoter.contacts_success_hl }}
                  </div>
                  <div class="text-center">{{$t('pharmastatistics.realized_contacts')}}</div>
                </div>
              </div>
            </va-card>
          </div>
        </div>
        <div class="row bottom-row">
          <div class="col-sm-12">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ promoter.contacts_no_success }}<!-- ou promoter.contacts_no_success ?? -->
                  </div>
                  <div class="text-center">{{$t('pharmastatistics.invalid_contacts')}}</div>
                </div>
              </div>
            </va-card>
          </div>
        </div>
      </div>

      <div class="col-sm-6 col-lg-3 px-3 section">
        <h5 class="section-title">{{$t('statistics.consultations')}}</h5>
        <div class="row">
          <div class="col-sm-12">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ promoter.scheduled_appointments }}
                  </div>
                  <div class="text-center">
                    {{$t('pharmastatistics.consultations_total')}}
                    <!-- <vuestic-tooltip :options="{content: this.$t('statistics.consultations_go_tooltip'), placement: 'bottom'}">
                      {{$t('pharmastatistics.consultations_total')}}
                      <i class="fa fa-info-circle"></i>
                    </vuestic-tooltip> -->
                  </div>
                </div>
              </div>
            </va-card>
          </div>
        </div>
        <div class="row bottom-row">
          <div class="col-sm-4 small-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ promoter.converted_to_appointment }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.100')}}</div>
                </div>
              </div>
            </va-card>
          </div>
          <div class="col-sm-4 small-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ promoter.appointment_missed }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.105')}}</div>
                </div>
              </div>
            </va-card>
          </div>
          <div class="col-sm-4 small-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ promoter.total_appointments }}
                  </div>
                  <div class="text-center">{{$t('statistics.consultations_made')}}</div>
                </div>
              </div>
            </va-card>
          </div>
        </div>
      </div>

      <div class="col-sm-6 col-lg-2 pl-3 section">
        <h5 class="section-title">{{$t('pharmastatistics.results')}}</h5>
        <div class="row">
          <div class="col-sm-12">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ promoter.qualified }}
                  </div>
                  <div class="text-center">{{$t('pyramid.lqe')}}</div>
                </div>
              </div>
            </va-card>
          </div>
        </div>
        <div class="row bottom-row">
          <div class="col-sm-6 small-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ promoter.appointment_not_applicable }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.101')}}</div>
                </div>
              </div>
            </va-card>
          </div>
          <div class="col-sm-6 small-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ promoter.appointment_ent }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.106')}}</div>
                </div>
              </div>
            </va-card>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import Multiselect from 'vue-multiselect'
import RankingGraph from '../agenda/statistics/components/RankingGraph'
import { StatisticsService } from '@/api/BookingService'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import IsFromEvolluMixin from '@/mixins/IsFromEvolluMixin'
import { PROMOTER_STATS } from '@/local-storage/LocalStorageKeys'
import RangeDatePicker from '@/components/common/RangeDatePicker'
import LocalStorageHelper from '@/local-storage/LocalStorageHelper'
import DashboardInfoWidgets from '../dashboard/DashboardInfoWidgets'
import * as criterias from './criterias'

export default {
  components: {
    Breadcrumbs,
    Multiselect,
    RankingGraph,
    RangeDatePicker,
    DashboardInfoWidgets
  },
  mixins: [
    IsFromEvolluMixin
  ],
  data () {
    return {
      isLoading: false,
      promoterstats: [],
      filters: {
        promoters: [],
        dateRange: {
          start: this.moment().subtract(1, 'months').format('YYYY-MM-DD'),
          end: this.moment().format('YYYY-MM-DD')
        }
      }
    }
  },
  computed: {
    requestParams: function () {
      return {
        from: this.filters.dateRange.start,
        until: this.filters.dateRange.end
      }
    },
    graph: function () {
      return {
        id: 1,
        name: this.$t('agenda.statistics.graphs.per_promoters.title'),
        labels: [
          { key: 'submitted', text: this.$t('agenda.statistics.graphs.per_facilities.labels.contacts'), color: '#266F62' },
          { key: 'submitted_hl', text: this.$t('agenda.statistics.graphs.per_facilities.labels.contactsWithLoss'), color: '#279381' },
          { key: 'lq_per_screenings', text: this.$t('agenda.statistics.graphs.per_promoters.labels.average_lq_screening'), color: '#28B199' },
          { key: 'screenings', text: this.$t('agenda.statistics.graphs.per_promoters.labels.screenings'), color: '#29C4A9' },
        ],
        dataset: this.promoterstats || [],
        dataset_key: 'promoter_name',
        criterias: [
          { id: 1, name: this.$t('agenda.statistics.criteria.by_contacts'), criteria: criterias.criteriaBySubmitted },
          { id: 2, name: this.$t('agenda.statistics.criteria.by_lq'), criteria: criterias.criteriaByLQs },
          { id: 3, name: this.$t('agenda.statistics.criteria.by_lqe'), criteria: criterias.criteriaByLQEs },
          { id: 4, name: this.$t('agenda.statistics.criteria.by_screenings'), criteria: criterias.criteriaByScreenings },
          { id: 5, name: this.$t('agenda.statistics.criteria.by_contacts_per_screening'), criteria: criterias.criteriaByAverageSubmittedsPerScreening },
          { id: 6, name: this.$t('agenda.statistics.criteria.by_lq_per_screening'), criteria: criterias.criteriaByAverageLQsPerScreening },
          { id: 7, name: this.$t('agenda.statistics.criteria.by_lqe_per_screening'), criteria: criterias.criteriaByAverageLQEsPerScreening }
        ],
        localStorageKey: 'PROMOTERSTATS_TOP_PROMOTERS'
      }
    },
  },
  methods: {
    loadBaseData () {
      this.isLoading = true
      StatisticsService.getPromoterStats(this.requestParams)
        .then(originalData => {
          const stats = originalData.promoters
          this.promoterstats = stats
          this.graph.dataset = stats
          this.filters.promoters = this.getSelectedPromoters(stats)
        }).catch((error) => {
          console.log(error)
          this.showToast(this.$t('statistics.something_went_wrong'), this.$store.state.errorToastOptions)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    loadLocalStorage: function () {
      return new Promise((resolve, reject) => {
        const state = LocalStorageHelper.get(PROMOTER_STATS)
        if (state !== null) {
          this.filters = {
            ...this.fitlers,
            ...state
          }
        }
        resolve()
      })
    },
    getSelectedPromoters: function (data) {
      if (!this.isFromEvollu) {
        return data.filter(stat => stat.promoter_id === this.$auth.user().id)
      } else {
        return data.filter(stat => this.filters.promoters.some(promoter => promoter.promoter_id === stat.promoter_id))
      }
    }
  },
  watch: {
    filters: {
      handler: function () {
        LocalStorageHelper.set(PROMOTER_STATS, this.filters)
      },
      deep: true
    },
    requestParams: function (value) {
      this.loadBaseData()
    }
  },
  mounted () {
    this.loadLocalStorage()
      .then(() => {
        this.loadBaseData()
      })
  }
}
</script>

<style lang="scss">
.promoter-stats-content {
  .va-card__body {
    overflow-x: unset;
  }
  .va-card.promoter-stats-widgets {
    -webkit-box-shadow: 0 0 3px 0 rgba(52, 56, 85, 0.25);
    box-shadow: 0 0 3px 0 rgba(52, 56, 85, 0.25);
    background-color: transparent;
  }
  .info-widget-inner {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    min-height: 100px !important;

    &.has-chart {
      justify-content: space-between;
    }

    .stats {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      height: 100%;
      min-height: 110px;
    }
  }
}

.stats-number {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 2.625rem;
  margin-bottom: 0.5rem;

  &.small-number {
    font-size: 1.8rem;
  }

  @media (min-width: 1600px) {
    &.small-number {
      font-size: 1.5rem;
    }
  }

  .stats-icon {
    font-size: 1.5625rem;
    position: absolute;
    top: 0.625rem;
    left: -1.25rem;

    &.icon-wide {
      left: -1.875rem;
    }
  }
}

.final-status .va-card {
  background: #d8dcdc;
}

.cancelled-status .va-card {
  background: #d8dcdc;
  color: #7d8888;
}

.final-status-success .va-card {
  background: #5dceb3;
}

</style>
